import { GetterTree, ActionTree, MutationTree } from 'vuex'

class State {
    canvas: any = null
}

const getters: GetterTree<State, any> = {
    canvas: (state) => state.canvas
}

const mutations: MutationTree<State> = {
    canvasHandler: (state, payload) => {
        const body = document.querySelector('body')

        if (body) {
            if (payload == 'left' || payload == 'right') {
                body.classList.add('hidden')
                window.scroll(0, 0)
            } else {
                body.classList.remove('hidden')
            }
        }

        state.canvas = payload
    }
}

const actions: ActionTree<State, any> = {}

export default {
    namespaced: true,
    state: new State(),
    mutations,
    actions,
    getters
}
